<template>
    <div id="chatHeader" :class="{ roundedHeader: roundedHeader }">
        <div class="header-container">
            <div class="left">
                <!--                <div class="icon-container">-->
                <!--                    <EllipsIconButton-->
                <!--                        padding="16px"-->
                <!--                        radius="10px"-->
                <!--                        :iconName="leftIconIndexes.includes(pageIndex) ? 'ArrowL' : 'ArrowB'"-->
                <!--                        bgColor="rgba(255, 255, 255, 0.31)"-->
                <!--                        @btnClicked="() => arrowButtonClickHandler()"-->
                <!--                    />-->
                <!--                </div>-->
                <div v-if="connected" class="user-container">
                    <div v-if="this.pageIndex === 1" style="display: flex; align-items: center">
                        <div class="image-container" v-if="chatAgents.length">
                            <a-avatar :username="agentName()" :src="getAgentImage()" class="avatar agent-avatar">
                                {{ agentName().substr(0, 1).toUpperCase() }}
                            </a-avatar>
                            <div class="status-dot"></div>
                        </div>
                        <div v-if="chatAgents.length" class="title-container text-container">
                            {{ representativeName || "" }}
                        </div>
                        <div v-else class="title-container text-container">
                            {{ title }}
                        </div>
                    </div>
                    <div v-else style="display: flex; align-items: center">
                        <div class="title-container text-container">
                            {{ defaultTitle }}
                        </div>
                    </div>
                </div>
                <div v-else class="waiting-header">
                    <span v-if="previewMode" style="color: var(--header-text-color)">John Doe</span>
                    <span v-else style="color: var(--header-text-color)" class="default-title-length">{{
                        defaultTitle
                    }}</span>
                </div>
            </div>
            <div class="options-container">
                <div class="options-button-container" id="optionOpenButton">
                    <EllipsIconButton
                        :iconName="leftIconIndexes.includes(pageIndex) ? 'BackIcon' : 'ArrowL'"
                        @btnClicked="() => arrowButtonClickHandler()"
                    />
                    <EllipsIconButton @btnClicked="toggleMenu" iconName="ThreeDot" />
                </div>
                <HeaderOptions
                    v-if="optionsIsVisible"
                    :connected="connected"
                    :isIframeMode="isIframeMode"
                    :visitorGDPRDeleteEnabled="visitorGDPRDeleteEnabled"
                    :ticketMode="ticketMode"
                    :volume="volume"
                    @closePopup="optionsIsVisible = false"
                    @showTicketForm="() => showTicketForm()"
                    @deleteKVKK="() => deleteKVKK()"
                    @showChatHistory="() => showChatHistory()"
                    @maximize="() => maximize()"
                    @localVolume="(volume) => (localVolume = volume)"
                    @closeChat="() => $emit('closeChat')"
                />
                <a-modal
                    :visible="langSelection"
                    centered
                    hide-footer
                    hide-header
                    :footer="null"
                    @cancel="langSelection = false"
                >
                    <div class="d-flex flex-column">
                        <h6 style="font-size: 14px; color: var(--color4) !important">
                            {{ $t("message.languageSelection") }}
                        </h6>
                        <a-select
                            v-model="preferredLang"
                            class="my-2"
                            show-search
                            option-filter-prop="children"
                            :filter-option="filterOption"
                            :autofocus="true"
                        >
                            <a-select-option v-for="lang in languages" :key="lang.code" :value="lang.code"
                                >{{ lang.originalName }}
                            </a-select-option>
                        </a-select>
                        <a-button
                            class="btnUpdateLang btn-lang-background"
                            type="primary"
                            variant="success"
                            @click="updateLang"
                        >
                            <span>
                                {{ $t("message.save") }}
                            </span>
                        </a-button>
                    </div>
                </a-modal>
            </div>
        </div>
    </div>
</template>

<script>
import CloseIcon from "./assets/close-icon-big.png";
import { mapActions, mapMutations, mapState } from "vuex";
import {
    parentWindowMessageStream,
    sendCommandToParentWindow,
    sendMaximizeAction,
    sendMinimizeAction,
} from "../../../utils/parentWindowConnection";
import * as _ from "lodash";
import { log2 } from "../../../utils/log2";
import { publishMessage, systemMessageStream, SystemMessageTypes } from "../../../utils/systemPubSub";
import languages from "../../../language/languages.json";
import { sendSocketMessage } from "../../../utils/socketStream";
import { filter, map } from "rxjs/operators";
import { getPersistenceData } from "../../../utils/persistenceStorage";
import Head from "../Head";
import CardHead from "./CardHead";
import HeaderOptions from "./HeaderOptions.vue";
import EllipsIconButton from "../../../common/IconButton.vue";

const log = log2("HeaderV2");
export default {
    name: "HeaderV2",
    components: {
        Head,
        CardHead,
        HeaderOptions,
        EllipsIconButton,
    },
    props: {
        icons: {
            type: Object,
            default: function () {
                return {
                    close: {
                        img: CloseIcon,
                        name: "default",
                    },
                };
            },
        },
        participants: {
            type: Array,
            required: true,
        },
        imageUrl: {
            type: String,
            required: true,
        },
        title: {
            type: String,
        },
        colors: {
            type: Object,
            required: true,
        },
        isRootCatalog: {
            type: Boolean,
            required: false,
            default: true,
        },
        ticketMode: {
            type: Boolean,
            required: true,
        },
        headerTitle: {
            type: String,
            required: false,
        },
    },
    computed: {
        ...mapState({
            connected: (state) => state.chat.connected,
            site: (state) => state.site.site,
            queueNumber: (state) => state.chat.queueNumber,
            chatAgents: (state) => state.chat.chatAgents,
            settings: (state) => state.setting.settings,
            visitorGDPRDeleteEnabled: (state) => _.get(state, "setting.settings.visitorGDPRDeleteEnabled", true),
            volume: (state) => state.app.volume,
            previewMode: (state) => state.app.previewMode,
            visitorId: (state) => state.chat.visitorId,
            autoTranslate: (state) => state.chat.autoTranslate,
            language: (state) => state.language.language,
            pageIndex: (state) => state.app.pageIndex,
            lastPageIndex: (state) => state.app.lastPageIndex,
        }),
        filteredMessages() {
            return this.messages.filter(
                (m) =>
                    "customer-typing" !== m.type &&
                    "private" !== m.type &&
                    ("undefined" !== typeof m.message || "undefined" !== typeof m.description) &&
                    m.systemMessageType !== "customer-offline" &&
                    m.systemMessageType !== "customer-online"
            );
        },
        defaultPageIndexes() {
            if (this.pageIndex === 4) {
                return this.$t("message.selectChatLang");
            } else if (this.pageIndex === 3) {
                return this.$t("message.chatHistory");
            } else if (this.pageIndex === 5) {
                return this.participants.length
                    ? this.participants[0].name.substr(0, 1).toUpperCase() +
                          " " +
                          this.$t("visitorLanguage.rateTheMeting")
                    : this.$t("visitorLanguage.rateTheEmptyMeting");
            } else if (this.pageIndex === 6) {
                return "";
            } else if (this.pageIndex === 2) {
                return this.$t("message.createTicket");
            } else {
                return this.$t("message.chatWithUs");
            }
        },
    },
    updated() {
        log("updated", {
            optionsIsVisible: this.optionsIsVisible,
        });
    },
    mounted() {
        if (this.chatAgents.length) {
            const newTitle = this.chatAgents[0].name;
            this.representativeName = newTitle.charAt(0).toUpperCase() + newTitle.slice(1);
        }

        let c1 = systemMessageStream
            .pipe(
                filter((x) => x.type === "SET_VISITOR_LANG"),
                map((x) => x.payload.lang)
            )
            .subscribe((x) => {
                this.preferredLang = x;
            });
        let c2 = systemMessageStream
            .pipe(
                filter((x) => x.type === "open-lang-modal"),
                map((x) => x.payload)
            )
            .subscribe((x) => {
                this.langSelection = x;
            });
        const openOptionsSub = parentWindowMessageStream
            .pipe(filter((x) => ["iframe-open"].includes(x.command)))
            .subscribe(({ command, payload }) => {
                payload = payload || {};
                if (payload["initWithTickets"]) {
                    this.closeChat();
                    this.showTicketForm();
                }
                if (payload["initWithLive"]) {
                    this.$emit("change-to-ticket", false);
                }
            });
        this.cancels.push(() => openOptionsSub.unsubscribe());
        this.cancels.push(() => c1.unsubscribe());
        this.cancels.push(() => c2.unsubscribe());
        this.$i18n.locale = this.languages.find((x) => x.code === this.preferredLang).code;
        if (window.self !== window.top) {
            this.roundedHeader = "roundedHeader";
        }
        log("mounted completed");
    },
    methods: {
        ...mapActions({
            resetConversation: "chat/resetConversation",
            updateVolume: "app/updateVolume",
            toggleAfterActions: "app/toggleAfterActions",
        }),

        ...mapMutations({
            setAutoTranslate: "chat/SET_AUTO_TRANSLATE",
            changePageIndex: "app/CHANGE_PAGE",
            goPrevPage: "app/GO_PREV_PAGE",
        }),
        getOrganizationLogo() {
            log("getOrganizationLogo");
            if (this.settings.organizationLogo && this.participants.length > 0) {
                const { path, id, ext } = this.settings.organizationLogo;
                this.organizationLogo =
                    this.participants[0].gravatar || `https://static.supsis.live/${path}${id}.${ext}`;
            } else {
                this.organizationLogo = "";
            }
        },
        toggleMenu() {
            this.$nextTick(() => {
                log("toggleMenu", !this.optionsIsVisible);
                this.optionsIsVisible = true;
            });
            this.$forceUpdate();
        },
        arrowButtonClickHandler() {
            if (this.leftIconIndexes.includes(this.pageIndex)) {
                return this.goPrevPage();
            }
            sendMinimizeAction();
        },
        updateLang() {
            this.$i18n.locale = this.preferredLang;
            this.langSelection = false;
            sendSocketMessage("visitor lang-change", {
                visitorId: this.visitorId,
                siteId: this.site._id,
                preferredLang: this.preferredLang,
                conversationId: getPersistenceData("conversationId"),
            });
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        deleteKVKK() {
            log("deleteKVKK");
            this.$emit("deleteKVKK");
        },
        showTicketForm() {
            log("showTicketForm");
            this.toggleAfterActions(false);
            this.resetConversation();
            publishMessage(SystemMessageTypes.RESTART_NEEDED, {});
            this.changePageIndex(2);
        },
        showChatHistory() {
            log("showChatHistory");
            this.changePageIndex(3);
        },
        openNewTab() {
            sendCommandToParentWindow("open-new-tab", {});
        },
        isIframeMode() {
            log("isIframeMode", window.parent !== window);
            // log("isIframeMode", window.parent !== window, window.parent != window);
            return window.parent !== window;
        },
        maximize() {
            sendMaximizeAction();
        },
        goBackToParent() {
            this.$emit("back-to-parent");
        },
        closeChat() {
            if (!this.previewMode) this.$emit("closeChat");
        },
        openFullscreen() {
            window.open("?catalog=fullscreen", "_blank");
        },
        agentName() {
            log("agentName", this.participants);
            return this.participants.length ? this.participants[0].name : this.$t("message.representative");
        },
        getAgentImage() {
            if (this.chatAgents.length > 0) {
                if (this.chatAgents[0]._id === "chatbot") {
                    if (
                        this.settings.chatbotAvatar &&
                        this.settings.chatbotAvatar.path &&
                        this.settings.chatbotAvatar.id &&
                        this.settings.chatbotAvatar.ext
                    ) {
                        return `https://static.supsis.live/${this.settings.chatbotAvatar.path}${this.settings.chatbotAvatar.id}.${this.settings.chatbotAvatar.ext}`;
                    } else {
                        return null;
                    }
                } else {
                    if (this.chatAgents[0].gravatar) {
                        return this.chatAgents[0].gravatar;
                    } else {
                        return null;
                    }
                }
            }
            return null;
        },
        getPageIndex() {
            return this.$t("message.chatWithUs");
        },
    },
    beforeDestroy() {
        log("beforeDestroy");
        for (const cancel of this.cancels) cancel();
    },

    data() {
        let langCode = navigator.language.split("-")[0].toLowerCase();
        let maybeLang = languages.find((x) => x.code === langCode);
        return {
            languages,
            langSelection: false,
            isSwitched: false,
            preferredLang: !!maybeLang ? maybeLang.code : "tr",
            optionsIsVisible: false,
            baseUrl: () => {
                if (document.currentScript) {
                    let _documentUrl = document.currentScript.src.split("/");
                    return _documentUrl[0] + "//" + _documentUrl[2] + "/";
                } else {
                    return "/";
                }
            },
            localVolume: 100,
            leftIconIndexes: [4, 3],
            cancels: [],
            bgColor: "var(--primary_)",
            defaultTitle: this.getPageIndex(),
            organizationLogo: null,
            roundedHeader: "",
            representativeName: null,
        };
    },

    watch: {
        "$i18n.locale": {
            handler: function (newLocale, oldLocale) {
                this.defaultTitle = this.getPageIndex();
            },
            deep: true,
        },
        chatAgents() {
            if (this.chatAgents && this.chatAgents.length > 0) {
                const newTitle = this.chatAgents[0].name;
                this.representativeName = newTitle.charAt(0).toUpperCase() + newTitle.slice(1);
            } else {
                this.representativeName = "";
            }
        },
        pageIndex() {
            if (this.pageIndex === 4) {
                this.defaultTitle = this.$t("message.selectChatLang");
            } else if (this.pageIndex === 3) {
                this.defaultTitle = this.$t("message.chatHistory");
            } else if (this.pageIndex === 5) {
                return this.participants.length
                    ? this.participants[0].name.substr(0, 1).toUpperCase() +
                          " " +
                          this.$t("visitorLanguage.rateTheMeting")
                    : this.$t("visitorLanguage.rateTheEmptyMeting");
            } else if (this.pageIndex === 6) {
                this.defaultTitle = "";
            } else if (this.pageIndex === 2) {
                this.defaultTitle = this.$t("message.createTicket");
            } else {
                this.defaultTitle = this.$t("message.chatWithUs");
            }
        },
        localVolume(newVal) {
            if (newVal !== this.volume) setTimeout(() => this.updateVolume(newVal), 100);
        },
        participants(newVal, oldVal) {
            if (this.participants.length && this.connected && this.organizationLogo === null) {
                this.getOrganizationLogo();
            }
            if (newVal.length === 1 && this.preferredLang !== newVal[0].lang && !this.autoTranslate) {
                this.setAutoTranslate(true);
                this.isSwitched = true;
            }
        },
    },
};
</script>

<style lang="scss">
body.v2 {
    @media (max-width: 450px) {
        .sc-header {
            border-radius: 0px;
        }
    }

    .title-chat {
        font-size: 1rem;
        line-height: 47px;
    }

    .agent-avatar {
        color: var(--header-text-color);
        width: 35px;
        height: 35px;
        overflow: hidden;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.31);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border: 1px solid var(--background-color-first) !important;
    }

    .status-dot {
        width: 10px;
        height: 10px;
        background-color: #25e472;
        border: 1.3px solid #fff;
        border-radius: 50%;
        position: fixed;
        top: 42px;
        left: 17px;
        -webkit-box-shadow: 0 1px 3px #25e472;
        box-shadow: 0 1px 3px #25e472;
    }

    .btn-lang-background {
        background-color: var(--button-color);
        border: 1px solid var(--button-color);
    }
}
.default-title-length {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/Header.vue